
<template>
  <div class="shareHeader">
      <div class="content" @click="toStore" v-if="content != 1">
        <Carousel autoplay :autoplay-speed="5000"  loop dots="none" arrow="never">
            <CarouselItem v-for="(item,index) in content.topList" :key="index">
              <div class="demo-carousel">
                <img :src="item.headImage?item.headImage:require('../images/headerImg.png')" alt="头像">
                <p>{{item.publisherName+' '+item.title}}</p> 
              </div>             
            </CarouselItem>
        </Carousel>
      </div>
      <!-- 固定宣传语 -->
      <div class="content contentVideo" @click="toStore" v-else>
        <img src="../images/logo.png" alt="">
        <span>殡葬业第一个交流、学习、分享平台</span> 
      </div>
      <div class="btn" @click="toStore">打开</div>      
      <v-downTip :popShow="popShow" ></v-downTip>
  </div>
</template>

<script>
import global from "../js/global.js"
export default {
  data () {
    return {
        popShow:false,
        value2:0,
    }
  },
  props:['content'],
  created(){
  },
  mounted(){
  },
  methods:{
    toStore(){
      this.popShow = global.toStore(this.content)
    },
    closeTip(){
      this.popShow = false;
    }
  }
}
</script>
<style lang="less" scoped>
.shareHeader{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 88px;
    background: #333440;
    padding: 18px 30px 18px 25px;
    z-index: 9;
    .content{
      float: left;
      width: 460px;
      height: 56px;
      overflow: hidden;
      img{
        width: 56px;
        height: 56px;
        border-radius: 8px;
        margin-right: 24px;
        vertical-align: top;
        float: left;
        margin-left:5px; 
        border-radius: 50%;
      }
      p{
          float: right;
          width: 370px;
          font-size: 24px;
          line-height: 56px;
          height: 56px;
          color: #FFFFFF;
          white-space:nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
      }
      .demo-carousel{
        background: #333440;
        overflow: hidden;
      }
    }
    .contentVideo{
      line-height: 56px;
      width: 490px;
      img{
        width: 56px;
        height: 56px;
        border-radius: 8px;
        margin-right: 24px;
        vertical-align: middle;
      }
      span{
          font-size: 24px;
          color: #FFFFFF;
      }
    }
    .btn{
        float: right;
        width: 120px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        background: #FFF1EF;
        border-radius: 200px;
        font-size: 24px;
        color: #E27574;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shareHeader.vue